import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const FacebookAd = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14941)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#BFCDFF"
          />
          <rect
            x="59.75"
            y="22.75"
            width="41.5"
            height="67.5"
            rx="7.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="72.2305"
            y="27"
            width="17.641"
            height="2"
            rx="1"
            fill="#1E1E1E"
          />
          <rect
            x="74.75"
            y="38.75"
            width="90.5"
            height="79.5"
            rx="1.25"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="74"
            y="77"
            width="92"
            height="2"
            fill="#1E1E1E"
          />
          <rect
            x="74"
            y="46"
            width="92"
            height="1.5"
            fill="#1E1E1E"
          />
          <rect
            x="81"
            y="62"
            width="77"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="81"
            y="69"
            width="61"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <rect
            x="93"
            y="54"
            width="19"
            height="4"
            rx="1"
            fill="#8C8C8C"
          />
          <circle
            cx="85"
            cy="55"
            r="4"
            fill="#8C8C8C"
          />
          <circle
            cx="151.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="156.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="161.5"
            cy="42.5"
            r="1.5"
            fill="#FFB700"
          />
          <circle
            cx="127"
            cy="90"
            r="3"
            fill="#0C5CEF"
          />
          <path
            d="M115.296 88.5799C115.396 88.4398 115.604 88.4398 115.704 88.5799L132.265 111.855C132.383 112.021 132.264 112.25 132.061 112.25H98.9388C98.7357 112.25 98.6174 112.021 98.7351 111.855L115.296 88.5799Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            d="M129.797 96.5616C129.897 96.4234 130.103 96.4234 130.203 96.5616L141.247 111.854C141.366 112.019 141.248 112.25 141.044 112.25H118.956C118.752 112.25 118.634 112.019 118.753 111.854L129.797 96.5616Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="157.75"
            y="10.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <g clipPath="url(#clip1_1503_14941)">
            <g clipPath="url(#clip2_1503_14941)">
              <path
                d="M172.24 41.4264C172.24 42.5494 172.492 43.408 172.82 43.9287C172.996 44.2251 173.248 44.4709 173.551 44.6411C173.855 44.8113 174.199 44.8998 174.549 44.8976C175.394 44.8976 176.167 44.6934 177.657 42.676C178.85 41.0599 180.257 38.7964 181.204 37.3671L182.807 34.9577C183.92 33.2844 185.206 31.4242 186.685 30.1593C187.89 29.1342 189.191 28.5625 190.501 28.5625C192.699 28.5625 194.793 29.8091 196.395 32.147C198.149 34.7076 199.003 37.9327 199.003 41.261C199.003 43.2396 198.605 44.6934 197.926 45.8419C197.272 46.9527 195.991 48.0625 193.843 48.0625V44.8976C195.682 44.8976 196.138 43.2437 196.138 41.3508C196.138 38.6535 195.496 35.6601 194.08 33.5212C193.075 32.0041 191.773 31.0771 190.341 31.0771C188.792 31.0771 187.545 32.2205 186.144 34.2594C185.399 35.3426 184.634 36.6627 183.776 38.1522L182.831 39.7857C180.932 43.0803 180.451 43.8307 179.501 45.0691C177.841 47.2457 176.42 48.0625 174.549 48.0625C172.33 48.0625 170.927 47.1222 170.063 45.7051C169.348 44.5505 169 43.0354 169 41.309L172.24 41.4264Z"
                fill="#0081FB"
              />
              <path
                d="M171.555 32.3706C173.04 30.1296 175.184 28.5625 177.643 28.5625C179.067 28.5625 180.483 28.9709 181.961 30.1562C183.578 31.4477 185.3 33.5743 187.452 37.0792L188.223 38.337C190.084 41.3712 191.144 42.9312 191.763 43.6684C192.56 44.6138 193.119 44.8935 193.843 44.8935C195.682 44.8935 196.138 43.2396 196.138 41.3467L198.997 41.2589C198.997 43.2375 198.598 44.6913 197.92 45.8399C197.272 46.9527 195.991 48.0625 193.843 48.0625C192.508 48.0625 191.324 47.7787 190.016 46.5709C189.01 45.6439 187.835 43.9971 186.93 42.5167L184.24 38.1185C182.89 35.9112 181.651 34.2655 180.935 33.5243C180.163 32.7188 179.173 31.7509 177.591 31.7509C176.311 31.7509 175.224 32.6299 174.314 33.9745L171.555 32.3706Z"
                fill="url(#paint0_linear_1503_14941)"
              />
              <path
                d="M177.591 31.7509C176.311 31.7509 175.224 32.6299 174.314 33.9745C173.028 35.8745 172.24 38.7045 172.24 41.4264C172.24 42.5494 172.492 43.408 172.82 43.9287L170.058 45.7051C169.348 44.5505 169 43.0354 169 41.309C169 38.1696 169.881 34.8974 171.555 32.3706C173.041 30.1296 175.184 28.5625 177.643 28.5625L177.591 31.7509Z"
                fill="url(#paint1_linear_1503_14941)"
              />
            </g>
          </g>
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1503_14941"
            x1="175.503"
            y1="37.8071"
            x2="196.158"
            y2="38.8731"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0064E1" />
            <stop
              offset="0.4"
              stopColor="#0064E1"
            />
            <stop
              offset="0.83"
              stopColor="#0073EE"
            />
            <stop
              offset="1"
              stopColor="#0082FB"
            />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1503_14941"
            x1="173.321"
            y1="42.7536"
            x2="173.321"
            y2="35.3007"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0082FB" />
            <stop
              offset="1"
              stopColor="#0064E0"
            />
          </linearGradient>
          <clipPath id="clip0_1503_14941">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
          <clipPath id="clip1_1503_14941">
            <rect
              width="30"
              height="30"
              fill="white"
              transform="translate(169 22)"
            />
          </clipPath>
          <clipPath id="clip2_1503_14941">
            <rect
              width="30"
              height="19.5"
              fill="white"
              transform="translate(169 28.5625)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
